import {Suspense} from 'react'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {CodeIcon, CommentDiscussionIcon, GitMergeIcon, TagIcon} from '@primer/octicons-react'
import {ActivityEmpty} from './activity/ActivityEmpty'
import {ActivityError} from './activity/ActivityError'
import {ActivityGroup} from './activity/ActivityGroup'
import {ActionItemsLoading} from './action-items/ActionItemsLoading'
import {buildEventGroups} from '../../helpers/catch-up-helpers'
import styles from './Activity.module.css'
import {useSuspenseActivityPageData} from './data/use-activity-page-data'
import {useLayoutRouteData} from '../../page-data/loaders/use-layout-route-data'

/** Activity section showing recent timeline updates since last engagement */
export function Activity() {
  return (
    <ErrorBoundary boundaryName="Activity" fallback={<ActivityError />}>
      <Suspense fallback={<ActionItemsLoading />}>
        <ActivityComponent />
      </Suspense>
    </ErrorBoundary>
  )
}

function ActivityComponent() {
  const {summary} = useSuspenseActivityPageData()
  const {
    urls: {changes},
  } = useLayoutRouteData()
  const groups = buildEventGroups(summary, changes)
  const hasGroups = groups.reviewerActivity || groups.codeChanges || groups.stateChanges || groups.metadataChanges

  if (!hasGroups) {
    return <ActivityEmpty />
  }

  return (
    <div className={styles.activityContainer}>
      {groups.codeChanges && <ActivityGroup icon={CodeIcon} item={groups.codeChanges} />}
      {groups.reviewerActivity && <ActivityGroup icon={CommentDiscussionIcon} item={groups.reviewerActivity} />}
      {groups.stateChanges && <ActivityGroup icon={GitMergeIcon} item={groups.stateChanges} />}
      {groups.metadataChanges && <ActivityGroup icon={TagIcon} item={groups.metadataChanges} />}
    </div>
  )
}
